import { ApolloLink } from 'apollo-link'
import { RetryLink } from 'apollo-link-retry'

import createHttpLink from './createHttpLink'
import onError from './onError'

const link = ApolloLink.from([onError, new RetryLink(), createHttpLink])

export default link
